// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityRequestBase {
    static getAttributeTypeMap() {
        return MedicalEligibilityRequestBase.attributeTypeMap;
    }
}
MedicalEligibilityRequestBase.discriminator = undefined;
MedicalEligibilityRequestBase.additionalProperties = false;
MedicalEligibilityRequestBase.attributeTypeMap = [
    {
        "name": "patient",
        "baseName": "patient",
        "type": "MedicalEligibilityPatientRequest"
    },
    {
        "name": "payor",
        "baseName": "payor",
        "type": "MedicalEligibilityPayorRequest"
    },
    {
        "name": "practice",
        "baseName": "practice",
        "type": "MedicalEligibilityPractice"
    },
    {
        "name": "prescriber",
        "baseName": "prescriber",
        "type": "MedicalEligibilityPrescriberRequest"
    },
    {
        "name": "treatmentDate",
        "baseName": "treatmentDate",
        "type": "Date"
    },
    {
        "name": "clientId1",
        "baseName": "clientId1",
        "type": "string"
    },
    {
        "name": "clientId2",
        "baseName": "clientId2",
        "type": "string"
    },
    {
        "name": "clientId3",
        "baseName": "clientId3",
        "type": "string"
    },
    {
        "name": "clientId4",
        "baseName": "clientId4",
        "type": "string"
    },
    {
        "name": "clientId5",
        "baseName": "clientId5",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityRequestBase.js.map